import {
  CREATEACCOUNTPERSONAL,
  DELETEACCOUNTPERSONAL,
  GETACCOUNTPERSONAL,
  UPDATEACCOUNTPERSONAL,
  SET_HOSPITAL_CODE,
  CREATECUSTOMPRODUCTFORACCOUNT,
  GETCUSTOMPRODUCTACCOUNT,
  UPDATECUSTOMPRODUCTACCOUNT,
  GETCHANNELPARTNERCUSTOMER,
} from "../actions/types";

const initialState = {
  selectedAccountData: null,
  selectedAccountId: null,
  selectedAccountPhone: null,
  selectedAccountProductId: null,
  accountpersonalList: [],
  channelPartnerCustomerList: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEACCOUNTPERSONAL:
      return {
        ...state,
        accountpersonalSaveStatus: action.payload.success,
      };
    case GETACCOUNTPERSONAL:
      return {
        ...state,
        accountpersonalList: action.payload.data,
      };
    case UPDATEACCOUNTPERSONAL:
      return {
        ...state,
        accountpersonalUpdateStatus: action.payload.success,
      };

    case DELETEACCOUNTPERSONAL:
      return {
        ...state,

        accountpersonalList: state.accountpersonalList.filter(
          (item) => item.id !== action.accountId,
        ),
        accountpersonalDeleteStatus: action.payload.success,
      };
    case SET_HOSPITAL_CODE:
      return {
        ...state,
        hospitalCode: action.payload,
      };
    case CREATECUSTOMPRODUCTFORACCOUNT:
      return {
        ...state,
        accountcustomproductSaveStatus: action.payload.success,
      };
    case GETCUSTOMPRODUCTACCOUNT:
      return {
        ...state,
        accountcustomproductlList: action.payload.data,
      };
    case UPDATECUSTOMPRODUCTACCOUNT:
      return {
        ...state,
        customproductUpdateStatus: action.payload.success,
      };
    case "SET_SELECTED_ACCOUNT_FULL_DATA":
      console.log("REDUCER MEIN DATA PAHUNCH GAYA:", action.payload); 
      return {
        ...state,
        selectedAccountData: action.payload,
      };
    case GETCHANNELPARTNERCUSTOMER:
      return {
        ...state,
        channelPartnerCustomerList: action.payload.data,
      };

    default:
      return state;
  }
}
